import { sharedState, ephermeralId } from '@/shared-state.js'
import { Entity, dateTransformer } from '@/lib/normalize.js'
import aravaipaLogo from '@/assets/img/aravaipa-logo.png'

export const raceEvent = new Entity(sharedState, 'raceEvent')
export const race = new Entity(sharedState, 'race')
export const participant = new Entity(sharedState, 'participant')
export const addon = new Entity(sharedState, 'addon')
export const addonVariant = new Entity(sharedState, 'addonVariant')
export const lineItem = new Entity(sharedState, 'lineItem')

raceEvent.define({
  races: [race],
  participants: { entity: [participant], parent: race, idAttr: 'raceId' },
  addons: [addon],

  startTime: dateTransformer,
  cutoffTime: dateTransformer,
  shirtCutoff: dateTransformer,
  lastImportAt: dateTransformer,
  createdAt: dateTransformer,
  updatedAt: dateTransformer,

  imageUrl: {
    get() {
      if (this.avatarSmUrl) return this.avatarSmUrl
      if (this.avatarUrl) return this.avatarUrl
      return aravaipaLogo
    },
  },
})

race.define({
  raceEvent: raceEvent,
  participants: [participant],

  startTime: dateTransformer,
  cutoff: dateTransformer,
})
race.readonly = ['linestring']

participant.define({
  race: race,
  raceEvent: raceEvent,
  lineItems: [lineItem],

  st: dateTransformer,
  ft: dateTransformer,
  registeredAt: dateTransformer,
  waveStartTime: dateTransformer,
  lastSeenAt: dateTransformer,
  pickedUpAt: dateTransformer,
  acceptedWaiverAt: dateTransformer,
  createdAt: dateTransformer,
  updatedAt: dateTransformer,
})

addon.define({
  addonVariants: [addonVariant],
  variants: [addonVariant],
})

addonVariant.define({
  addon: addon,
  lineItems: [lineItem],
})

lineItem.define({
  participant: participant,
  addonVariant: addonVariant,
})

export function singularize(entityName) {
  if (undefined === entityName || null === entityName) return entityName
  if (entityName[entityName.length - 1] !== 's') return entityName
  return entityName.substr(0, entityName.length - 1)
}

export function pluralize(entityName) {
  if (undefined === entityName || null === entityName) return entityName
  if (entityName[entityName.length - 1] === 's') return entityName
  return entityName + 's'
}

export function reflect(entity, relationEntity) {
  let isToMany = false
  const relationKey = Object.keys(relationEntity.schema).find(backRel => {
    const backSchema = relationEntity.schema[backRel]

    if (Array.isArray(backSchema) && backSchema[0] === entity) {
      isToMany = true
      return true
    }

    return backSchema === entity
  })

  if (!relationKey) return {}
  return { isToMany, relationKey }
}

export function newEphemeralObject(entity, state, defaults = {}) {
  const id = ephermeralId()
  const obj = Object.create(entity.proto)

  for (let [key, value] of Object.entries(defaults)) {
    obj[key] = value
  }

  obj[entity.idAttr] = id

  for (const rel of Object.keys(entity.relationships)) {
    const relationship = entity.relationships[rel]
    obj[rel + (relationship.repeat ? 'Ids' : 'Id')] = relationship.repeat ? [] : undefined
  }

  state[entity.key][id] = obj
  return obj
}

export default {
  pluralize,
  singularize,
  reflect,
  raceEvent,
  race,
  participant,
  addon,
  addonVariant,
  lineItem,
}
